import { useCallback } from "react";
import { editStorageObject } from "../../../app/state/storageObjectSlice/actions/actions";
import { useStorageSelectors } from "../../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { CasesValue } from "../../../services/api/instances/casesApi/types";
import { useAppDispatch } from "../../../services/redux/hooks/use-dispatch";
import { useAppSelector } from "../../../services/redux/hooks/use-selector";
import {
  selectCaseMode,
  selectIsLocked,
  selectCaseEntityMode,
} from "../redux/selectors";
import { setCaseEntityMode, setCaseMode, setCaseValue } from "../redux/slice";

export const useCaseCreatorHeader = () => {
  const dispatch = useAppDispatch();
  const { selectedObject } = useStorageSelectors("cases");
  const caseMode = useAppSelector(selectCaseMode);
  const isLocked = useAppSelector(selectIsLocked);
  const entityMode = useAppSelector(selectCaseEntityMode);
  const handleChangeCaseStateMode = useCallback(() => {
    dispatch(setCaseEntityMode(entityMode === "case" ? "agent" : "case"));
  }, [dispatch, entityMode]);

  const handleChangeCaseMode = () => {
    dispatch(setCaseMode(caseMode === "create" ? "table" : "create"));
  };

  const handleFreezeCase = useCallback(() => {
    if (selectedObject?.value) {
      const newValue: CasesValue = {
        ...selectedObject?.value,
        metadata: {
          ...selectedObject?.value.metadata,
          is_locked:
            selectedObject?.value.metadata?.is_locked === undefined
              ? true
              : !selectedObject.value.metadata.is_locked,
        },
      };
      dispatch(setCaseValue(newValue));
      dispatch(
        editStorageObject({
          id: selectedObject.id,
          name: selectedObject.friendly_name,
          value: newValue,
          service: "cases",
        }),
      );
    }
  }, [selectedObject?.value]);

  return {
    isLocked,
    entityMode,
    handleChangeCaseStateMode,
    handleChangeCaseMode,
    handleFreezeCase,
  };
};
